import React from 'react';
import { Box } from '../../../../../base/Box/Box';
import Link from '../../../../../base/Link/Link';
import { MultilinkStoryblok } from '../../../../../types/storyblok';

type Props = {
  link: MultilinkStoryblok;
  heading: string;
};

export const External = ({ heading, link }: Props) => (
  <Box as="div" className="mt-3 flex items-end justify-between">
    <Link href={link} className="font-helvetica text-h3 lg:text-h1">
      {heading}
    </Link>
    <Box as="div">
      <Link link={link} variant="arrow-right" empty />
    </Box>
  </Box>
);
